import request from '@/utils/request'
import { encrypt } from '@/utils/rsaEncrypt'

export function add(data) {
  return request({
    url: 'api/users',
    method: 'post',
    data
  })
}
// 根据用户id获取已授权的角色
export function getUserRole(id) {
  return request({
    url: '/api/users/' + id + '/roles',
    method: 'get'
  })
}
export function del(ids) {
  return request({
    url: 'api/users',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'api/users',
    method: 'put',
    data
  })
}
export function editStatus(data) {
  return request({
    url: 'api/users/status',
    method: 'put',
    data
  })
}
export function editUser(data) {
  return request({
    url: 'api/users/center',
    method: 'put',
    data
  })
}

export function updatePass(user) {
  const data = {
    oldPass: encrypt(user.oldPass),
    newPass: encrypt(user.newPass)
  }
  return request({
    url: 'api/users/updatePass/',
    method: 'post',
    data
  })
}
export function updatePayPass(user) {
  const data = {
    oldPass: encrypt(user.oldPass),
    newPass: encrypt(user.newPass)
  }
  return request({
    url: 'api/sys/users/updatePayPass/',
    method: 'post',
    data
  })
}
export function updateEmail(form) {
  const data = {
    password: encrypt(form.pass),
    email: form.email
  }
  return request({
    url: 'api/users/updateEmail/' + form.code,
    method: 'post',
    data
  })
}
export function restUserPass(user) {
  const data = {
    userId: user.userId,
    newPass: encrypt(user.newPass)
  }
  return request({
    url: 'api/users/restPassword',
    method: 'put',
    data
  })
}
// 检查登录密码是否已过期，返回 true 表示已过期
export function checkPwdExpire() {
  return request({
    url: '/api/users/pwd/expire/check',
    method: 'get'
  })
}

// 发送重置登录密码短信验证码
export function sendResetPwdSms() {
  return request({
    url: '/api/users/password/reset/sms',
    method: 'post'
  })
}

// 通过短信验证码重置登录密码
export function resetPwdBySms(data) {
  return request({
    url: '/api/users/password/reset',
    method: 'put',
    data
  })
}

export default { add, edit, del, getUserRole, editStatus, restUserPass, checkPwdExpire, sendResetPwdSms, resetPwdBySms }

